goog.provide("shadow.js.shim.module$ol$View$default");
shadow.js.shim.module$ol$View$default = shadow.js.require(292, {})["default"];
